import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip } from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import PropTypes from 'prop-types';
import DataEmptyState from '../../../commons/dataemptystate';
import NetworkEmptyState from '../../../commons/networkemptystate';
import Service from './services';
import { PaginationTotal } from '../../../commons/controls';
import Lib from '../../../commons/lib';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import RFForm from '../../../components/Form/RFForm';
import RFField from '../../../components/Form/RFField';
import ProgressButton from '../../../commons/ProgressButton';

class FizetesimodLista extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalForm: false,
      modalTorles: false,
      dataLoaded: false,
      dataFailed: false,
      fizetesimodLista: [],
      fizetesimod: {},
      statusz: [],
      statuszOptions: [],
      filterOptions: {},
      addButtonLoading: false,
      modifyButtonLoading: false,
      deleteButtonLoading: false,
    };
  }

  componentDidMount() {
    this.updateTable();
  }

  updateTable = () => {
    this.setState({
      dataLoaded: false, dataFailed: false, fizetesimodLista: [], fizetesimod: {}
    });
    Service.listFizetesimod((err, res) => {
      if (err) {
        this.setState({ dataFailed: true });
      } else {
        let filters = {};
        let options = res[0].statusz.map((e) => {
          filters[e.name] = e.caption;

          return <option key={e.name} value={e.name}>{e.caption}</option>;
        });
        this.setState({
          fizetesimodLista: res[0].list,
          statusz: res[0].statusz,
          statuszOptions: options,
          filterOptions: filters,
          dataLoaded: true,
          dataFailed: false,
        });
      }
    });
  }

  toggleForm = (updateTable) => {
    this.setState({ modalForm: !this.state.modalForm }, () => {
      if (updateTable && typeof updateTable === 'function') updateTable();
    });
  }

  toggleTorles = () => {
    this.setState({ modalTorles: !this.state.modalTorles });
  }

  handleCancel = () => {
    this.setState({ modalForm: !this.state.modalForm }, () => {
      this.updateTable();
    });
  }


  handleEditClick = (id) => {
    Service.getFizetesimod(id, (err, res) => {
      if (!err) {
        let obj = res[0];
        obj.aktiv = obj.aktiv ? 'Aktív' : 'Inaktív';
        this.setState({ fizetesimod: res[0] }, () => { this.toggleForm(); });
      }
    });
  }

  handleDeleteClick = (id) => {
    this._currentDeleteId = id;
    this.toggleTorles();
  }

  iconFormatter = (cell) => {
    return (
      <div>
        {
          this.props.globals.hasRole(['PENZUGYKOZOS_FIZMOD'], true) && (
            <React.Fragment>
              <Button className="icon-pencil table-action-icon" id={'action-edit-' + cell} onClick={() => this.handleEditClick(cell)} />
              <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-edit-' + cell} delay={10}>
                Módosítás
              </UncontrolledTooltip>
              <Button className="icon-trash table-action-icon" id={'action-delete-' + cell} onClick={() => this.handleDeleteClick(cell)} />
              <UncontrolledTooltip trigger='hover focus-visible' placement="left" target={'action-delete-' + cell} delay={10}>
                Törlés
              </UncontrolledTooltip>
            </React.Fragment>
          )}
      </div>
    );
  }

  /**
  * Visszaadja az apartmanhoz tartozó státus jelvényeket.
  * @param {boolean} cell - Cella adatot tartalmazó szöveg.
  * @return {ReactElement} Státusz jelvényt tartalmazó react objektum.
  */
  statusFormatter = (cell) => {
    let statusz = this.state.statusz.find(x => x.name === cell);
    return statusz ? <span className={'badge badge-' + statusz.bagde}>{statusz.caption}</span> : 'N/A';
  }

  saveFizetesimod = (event, obj) => {
    if (this.state.fizetesimod && !this.state.fizetesimod.id) {
      this.insert(obj);
    } else {
      obj.id = this.state.fizetesimod.id;
      this.edit(obj);
    }
  }

  insert = (obj) => {
    this.setState({ addButtonLoading: true });
    Service.addFizetesimod(obj, (err) => {
      if (!err) {
        this.toggleForm(() => this.updateTable());
        this.props.globals.addSuccess('Fizetési mód hozzáadva!');
      }
      this.setState({ addButtonLoading: false });
    });
  }


  edit = (obj) => {
    this.setState({ modifyButtonLoading: true });
    Service.editFizetesimod(obj, (err) => {
      if (!err) {
        this.toggleForm(() => this.updateTable());
        this.props.globals.addSuccess('Fizetési mód módosítva!');
      }
      this.setState({ modifyButtonLoading: false });
    });
  }

  deleteFizetesimod = (id) => {
    this.setState({ deleteButtonLoading: true });
    this.toggleTorles();
    Service.deleteFizetesimod(id, (err) => {
      if (!err) {
        this.updateTable();
        this.props.globals.addSuccess('Fizetési mód törölve!');
      }
      this.setState({ deleteButtonLoading: false });
    });
  }

  renderTable = () => {
    const options = {
      sizePerPage: 5,
      showTotal: true,
      paginationTotalRenderer: PaginationTotal,
      sizePerPageList: [
        { text: '5', value: 5 },
        { text: '10', value: 10 },
        { text: '25', value: 25 }
      ],
    };


    const columns = [
      {
        dataField: 'kod',
        text: 'Fizetési mód kódja',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'nev',
        text: 'Fizetési mód neve',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'normal' },
      },
      {
        dataField: 'varians',
        text: 'Variánsok',
        filter: textFilter({
          delay: 400,
          placeholder: 'Keresés...',
        }),
        style: { whiteSpace: 'pre-line' },
      },
      {
        dataField: 'allapot',
        text: 'Státusz',
        formatter: this.statusFormatter,
        filter: selectFilter({
          options: this.state.filterOptions,
          placeholder: 'Összes',
          condition: 'eq'
        }),
        style: { whiteSpace: 'normal' },
        align: 'center'
      },
      {
        dataField: 'id',
        text: 'Műveletek',
        formatter: this.iconFormatter,
        hidden: !this.props.globals.hasRole(['PENZUGYKOZOS_FIZMOD'], true)
      },
    ];

    return this.state.fizetesimodLista.length ?
      <BootstrapTable
        bootstrap4
        keyField="id"
        columns={columns}
        data={this.state.fizetesimodLista}
        filter={filterFactory()}
        pagination={paginationFactory(Lib.bootstraptableProps)}
      />
      : <DataEmptyState />;
  }

  renderLoader = () => {
    return (
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {
          this.props.globals.hasRole(['PENZUGYKOZOS_FIZMOD'], true) && (
            <div className="row">
              <div className="col-sm-12">
                <Button className="pull-left table-new-button" color="primary" onClick={this.toggleForm}>Új fizetési mód</Button>
              </div>
            </div>
          )}
        {(this.state.dataLoaded && !this.state.dataFailed) ? this.renderTable() : (this.state.dataFailed) ? <NetworkEmptyState submitClick={this.updateTable} /> : this.renderLoader()}
        <Modal isOpen={this.state.modalTorles} toggle={this.toggleTorles} className={this.props.className} backdrop="static">
          <ModalHeader>Törlés</ModalHeader>
          <ModalBody>
              Valóban törölni kívánod a kiválasztott tételt?
          </ModalBody>
          <ModalFooter>
            <ProgressButton loading={this.state.deleteButtonLoading} className="btn-cursor-pointer" color="primary" onClick={() => this.deleteFizetesimod(this._currentDeleteId)}>OK</ProgressButton>
            <Button className="btn-cursor-pointer" type="button" color="secondary" onClick={this.toggleTorles}>Mégsem</Button>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.modalForm} toggle={this.toggleForm} className={this.props.className} backdrop="static" >
          <RFForm
            modal
            onSubmit={this.saveFizetesimod}
            title={!this.state.fizetesimod.id ? 'Új fizetési mód rögzítése' : 'Fizetési mód módosítása'}
            footer={
              <>
                <ProgressButton color="primary" loading={!this.state.fizetesimod.id ? this.state.addButtonLoading : this.state.modifyButtonLoading}>Mentés</ProgressButton>{' '}
                <Button type="button" color="secondary" onClick={this.handleCancel} >Mégsem</Button>
              </>
            }
          >
            <RFField
              label="Fizetési mód kódja:" 
              name="kod"
              value={this.state.fizetesimod.kod}
              required
              maxLength="3"
              disabled={this.state.fizetesimod.id}
            />
            <RFField
              label="Fizetési mód neve:"
              name="nev"
              value={this.state.fizetesimod.nev}
              required
              maxLength="50"
            />
            <RFField
              type="select"
              name="statusz"
              label="Státusz:"
              ref="statusz"
              value={this.state.fizetesimod.statusz}
              required
              defaultSelect={<option value="" disabled >Válassz státuszt...</option>}
              selectOptions={this.state.statuszOptions}
            />
          </RFForm>
        </Modal>
      </div>
    );
  }
}

FizetesimodLista.propTypes = {
  active: PropTypes.bool,
  globals: PropTypes.object,
  className: PropTypes.string,
};

export default FizetesimodLista;
